<template>
  <div class="loading-spinner">
    <div class="loading-spinner__mask" />
    <div class="loading-spinner__spinner" />
  </div>
</template>
<style lang="postcss">
.loading-spinner {
  .loading-spinner__mask {
    position: absolute;
    inset: 0;
    width: 100%;
    height: 100%;
    background-color: var(--mask-bg-light);
    opacity: 0.6;
    z-index: var(--z-loader);
  }
  .loading-spinner__spinner {
    position: absolute;
    top: 50%;
    left: 50%;
    translate: -50% -50%;
    border: 0.5rem solid var(--border-neutral-30);
    border-top: 0.5rem solid var(--border-dark-10);
    border-radius: 50%;
    width: 8rem;
    height: 8rem;
    z-index: var(--z-loader);
    animation: spin 1s linear infinite;
  }
}

@keyframes spin {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}
</style>
